<div class="row mt-5" *ngIf="currentReport && currentReport.LATEST && calculationVisible">
  <div class="col-lg-5 col-md-12 conclusion-lard" [class.p-0]="isLoading">
    <app-div-loading [displayText]="'Calculating...'" *ngIf="isLoading"></app-div-loading>
    <ng-container *ngIf="!isLoading && currentReport && currentReport.LATEST">
      <div class="text-center font-weight-bold pb-3" @enterLeaveAnimation>
        <div class="row conclusion-box--wrapper">
          <div class="col-md-12">
            <div class="green-icon">
              <img src="../../../../assets/images/document.svg" alt="...">
            </div>
          </div>

          <div class="col-md-12 mt-4">
            <div class="card-header-text">
              Valuation of
              <span class="color--blue ellipsis w-100" [popover]="currentReport?.LATEST?.COMPANY?.NAME?.length > 24 ? currentReport?.LATEST?.COMPANY?.NAME : ''"
              triggers="mouseenter:mouseleave" placement="top" [adaptivePosition]="true" container="body">{{currentReport?.LATEST?.COMPANY?.NAME}}</span> is
              <span class="text-success" *ngIf="marketValue">Completed</span>
              <span class="text-danger" *ngIf="!marketValue">{{errorMessage}}</span>
            </div>
          </div>

          <div class="col-md-12 my-3 p-3">
            <div class="gray-box">
              <div class="table-label font-weight-bold h-auto">The {{valueApproach ? valueApproach : 'value'}} (rounded)
                is best expressed as
              </div>
              <div class="color--blue font-size-45 my-2" [class.blur__div]="isBlur">
                <ng-container *ngIf="isBlur">$000,000</ng-container>
                <ng-container *ngIf="!isBlur">${{marketValue | number}}</ng-container>
              </div>
              <div class="color--light--gray font-size-12" *ngIf="reportService.hasOwnedLocationsOnBalance()">Excludes
                real estate owned by Company</div>
            </div>
          </div>

          <div class="col-md-12 mb-10 position-relative">
            <button type="button" *ngIf="currentReport.STATE == ReportState.LOCKED && currentReport?.CREATED_BY?.ID == userService.getUserId()"
              class="button primary__button large__button w-100 mt-2" (click)="openPaymentPopup(true)">
              Unlock the report
              <svg-icon name="credit_card_light" svgClass="ml-3"></svg-icon>
            </button>
          </div>
          <!-- <button (click)="lockReport()">lock</button> -->

          <div class="col-md-12 bg-white position-relative mb-10" *ngIf="currentReport.STATE == ReportState.CREATED && currentReport?.CREATED_BY?.ID == userService.getUserId()">
            <button type="button" class="button primary__button large__button w-100" (click)="openPaymentPopup(false)">
              Buy Report
              <svg-icon name="credit_card_light" svgClass="ml-3"></svg-icon>
            </button>
          </div>

          <!-- <div class="col-md-12 bg-white position-relative mb-3" *ngIf="currentReport.STATE != ReportState.CREATED && !userService.isOrganizationType_SBDC"> -->
          <div class="col-md-12 bg-white position-relative mb-3" *ngIf="currentReport.STATE != ReportState.CREATED">
            <button id="conclusion-download-full-report" type="button"
              class="button large__button primary__button w-100" [disabled]="isBlur" (click)="downloadReportPDF(false)">
              Download Full PDF Report
              <img src="../../../../assets/images/white-note-icon.svg" class="ml-3" alt="...">
            </button>
          </div>

          <div class="col-md-12 bg-white position-relative mb-3" *ngIf="currentReport.STATE == ReportState.CREATED">
            <button id="conclusion-download-full-report-sample" type="button"
              class="button large__button secondary__button w-100" (click)="downloadSample()">
              See a Sample Report
              <svg-icon name="notes" svgClass="ml-3"></svg-icon>
            </button>
          </div>

          <!-- View Report -->
          <!--<div class="col-md-12 bg-white position-relative mb-3" *ngIf="userService.isOrganizationType_SBDC">
            <button id="conclusion-download-full-report-view" type="button"
                    class="button large__button secondary__button w-100" (click)="viewReport()">
              View Report
              <svg-icon name="notes" svgClass="ml-3"></svg-icon>
            </button>
          </div>-->

        </div>
      </div>
    </ng-container>
  </div>

  <div class="col-lg-7 col-md-12 conclusion-info"
    *ngIf="currentReport && currentReport.LATEST && currentReport.LATEST.BALANCE_SHEET">
    <div class="label">Assets Included</div>
    <div class="mt-3 mb-4">
      <div class="row conclusion-info--row">
        <div class="col-md-8 col-8 div-table-label">Cash and Equivalents</div>
        <div class="col-md-4 col-4 div-table-value">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform(currentReport.LATEST.BALANCE_SHEET.ASSET_CASH || 0)}}
          </span>
        </div>
      </div>
      <div class="row conclusion-info--row">
        <div class="col-md-8 col-8 div-table-label">Accounts Receivable</div>
        <div class="col-md-4 col-4 div-table-value">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform(currentReport.LATEST.BALANCE_SHEET.ASSET_AR || 0)}}
          </span>
        </div>
      </div>
      <div class="row conclusion-info--row">
        <div class="col-md-8 col-8 div-table-label">Inventory</div>
        <div class="col-md-4 col-4 div-table-value">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform(currentReport.LATEST.BALANCE_SHEET.ASSET_INVENTORY || 0)}}
          </span>
        </div>
      </div>
      <div class="row conclusion-info--row">
        <div class="col-md-8 col-8 div-table-label ellipsis"
          [popover]="currentReport.LATEST.BALANCE_SHEET?.ASSET_OTHER_LABEL?.length > 35 ? currentReport.LATEST.BALANCE_SHEET.ASSET_OTHER_LABEL : ''"
          triggers="mouseenter:mouseleave" placement="bottom left">
          {{currentReport.LATEST.BALANCE_SHEET.ASSET_OTHER_LABEL ? currentReport.LATEST.BALANCE_SHEET.ASSET_OTHER_LABEL
          : 'Other Assets'}}
        </div>
        <div class="col-md-4 col-4 div-table-value">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform(currentReport.LATEST.BALANCE_SHEET.ASSET_OTHER || 0)}}
          </span>
        </div>
      </div>
    </div>

    <div class="label">Liabilities Included</div>
    <div class="mt-3 mb-4">
      <div class="row conclusion-info--row">
        <div class="col-md-8 col-8 div-table-label">Accounts Payable</div>
        <div class="col-md-4 col-4 div-table-value" *ngIf="!isDebtRefinance">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform(currentReport.LATEST.BALANCE_SHEET.LIABILITY_AP || 0)}}
          </span>
        </div>
        <div class="col-md-4 col-4 div-table-value" *ngIf="isDebtRefinance">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform((currentReport.LATEST.BALANCE_SHEET.LIABILITY_AP || 0) -
            (currentReport.LATEST.BALANCE_SHEET.LIABILITY_AP_REF || 0))}}
          </span>
        </div>
      </div>
      <div class="row conclusion-info--row">
        <div class="col-md-8 col-8 div-table-label">Short Term Notes</div>
        <div class="col-md-4 col-4 div-table-value" *ngIf="!isDebtRefinance">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform(currentReport.LATEST.BALANCE_SHEET.LIABILITY_SHORT_TERM_NOTES || 0)}}
          </span>
        </div>
        <div class="col-md-4 col-4 div-table-value" *ngIf="isDebtRefinance">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform((currentReport.LATEST.BALANCE_SHEET.LIABILITY_SHORT_TERM_NOTES || 0) -
            (currentReport.LATEST.BALANCE_SHEET.LIABILITY_SHORT_TERM_NOTES_REF || 0))}}
          </span>
        </div>
      </div>
      <div class="row conclusion-info--row">
        <div class="col-md-8 col-8 div-table-label">Long Term Debt</div>
        <div class="col-md-4 col-4 div-table-value" *ngIf="!isDebtRefinance">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform(currentReport.LATEST.BALANCE_SHEET.LIABILITY_LONG_TERM || 0)}}
          </span>
        </div>
        <div class="col-md-4 col-4 div-table-value" *ngIf="isDebtRefinance">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform((currentReport.LATEST.BALANCE_SHEET.LIABILITY_LONG_TERM || 0) -
            (currentReport.LATEST.BALANCE_SHEET.LIABILITY_LONG_TERM_REF || 0))}}
          </span>
        </div>
      </div>
      <div class="row conclusion-info--row">
        <div class="col-md-8 col-8 div-table-label ellipsis"
          [popover]="currentReport.LATEST.BALANCE_SHEET?.LIABILITY_OTHER_LABEL?.length > 35 ? currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_LABEL : ''"
          triggers="mouseenter:mouseleave"
          placement="bottom left">
          {{currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_LABEL ?
          currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_LABEL : 'Other Liabilities'}}
        </div>
        <div class="col-md-4 col-4 div-table-value" *ngIf="!isDebtRefinance">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform(currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER || 0)}}
          </span>
        </div>
        <div class="col-md-4 col-4 div-table-value" *ngIf="isDebtRefinance">
          <span [class.blur__div]="isBlur">
            ${{currencyPipe.transform((currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER || 0) -
            (currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_REF || 0))}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row my-5 un__complete" *ngIf="currentReport && currentReport.LATEST && !calculationVisible">
  <div class="col-md-12 text-center">
    <svg-icon name="blue-puzzle"></svg-icon>
    <div class="header">Missing Answers</div>
    <div class="small__text">There are sections that has missing answers that are integral to calculating a final value.
    </div>
    <svg-icon name="blue-arrow-down"></svg-icon>
  </div>

  <div class="col-md-12 mt-4">
    <ng-container *ngFor="let page of invalidPageList; let i = index;">
      <!-- #region "Company information" -->
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.OVERVIEW" (click)="gotoPage('overview')">
        <span>
          Company information > Overview
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.LOCATION" (click)="gotoPage('location')">
        <span>
          Company information > Location
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" svgClass="svg__image" *ngIf="page.pageId === reportPageConst.OWNERSHIP" (click)="gotoPage('ownership')">
        <span>
          Company information > Ownership
          <svg-icon name="blue-caret-right"></svg-icon>
        </span>
      </div>
      <!-- #endregion -->

      <!-- #region "Financials" -->
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.INCOME" (click)="gotoPage('income')">
        <span>
          Financials > Income
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.FUTURE_PROJECTION"
        (click)="gotoPage('future-projection')">
        <span>
          Financials > Future Projection
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.RENT" (click)="gotoPage('rent/rent-details')">
        <span>
          Financials > Rent
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link"
        *ngIf="page.pageId === reportPageConst.OWNERS_SALARY && reportService.showOwnershipSalary() == 1"
        (click)="gotoPage('salary/manager-salary')">
        <span>
          Financials > Owner’s Salary
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link"
        *ngIf="page.pageId === reportPageConst.OWNERS_SALARY && reportService.showOwnershipSalary() == 2"
        (click)="gotoPage('salary/replacement-salary')">
        <span>
          Financials > Owner’s Salary
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.ADJUSTMENTS" (click)="gotoPage('adjustments')">
        <span>
          Financials > Adjustments
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.WEIGHTINGS"
        (click)="gotoPage('weighting/weighting-table')">
        <span>
          Financials > Weighting
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.PROJECTION"
        (click)="gotoPage('projections/projection-table')">
        <span>
          Financials > Projections
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.ASSETS_LIABILITIES"
        (click)="gotoPage('assets-liabilities')">
        <span>
          Financials > Assets / Liabilities
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <!-- #endregion -->

      <!-- #region "Risk" -->
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.DIVERSIFICATION"
        (click)="gotoPage('risk/diversification')">
        <span>
          Risk > Diversification / Concentration
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.PERSONAL_GOODWILL"
        (click)="gotoPage('risk/personal-goodwill')">
        <span>
          Risk > Personal Goodwill
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.BARRIERS_ENRTY"
        (click)="gotoPage('risk/barriers-entry')">
        <span>
          Risk > Barriers to Entry
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <div class="goto__link" *ngIf="page.pageId === reportPageConst.RECURRING_REVENUE"
        (click)="gotoPage('risk/recurring-revenue')">
        <span>
          Risk > Recurring Revenue
          <svg-icon name="blue-caret-right" svgClass="svg__image"></svg-icon>
        </span>
      </div>
      <!-- #endregion -->
    </ng-container>

  </div>

</div>

<div class="custom-debug-window" *ngIf="showCustomDebug">
  <div class="row">
    <div class="col-md-12" *ngFor="let info of debugInformation">
      {{info}}
    </div>
  </div>
</div>

<report-footer [nextBtnText]="'Go to Dashboard'" (buttonClicked)="footerButtonClick($event)"
  [pageId]="reportPageConst.CONCLUSION" [nextBtnEnable]="!calculatingFinalValue && !validatingReport">
</report-footer>
